module.exports = __webpack_public_path__ + "img/16.27b88ec2.png";